
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webstories",
      function () {
        return require("private-next-pages/webstories/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webstories"])
      });
    }
  